import React, { useState } from 'react';
import { Typography, ClickAwayListener } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LanguageSwitcher = ({ alwaysOpen = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = (i18n.resolvedLanguage || 'en').toUpperCase();

  const choose = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  if (!alwaysOpen && !open) {
    return (
      <Typography
        onClick={() => setOpen(true)}
        className={`${styles.root} ${styles.option}`}
      >
        {current}
      </Typography>
    );
  }

  const options = (
    <Typography className={styles.root}>
      <span
        onClick={() => choose('nl')}
        className={current === 'NL' ? styles.active : styles.option}
      >
        NL
      </span>
      <span className={styles.divider}>|</span>
      <span
        onClick={() => choose('en')}
        className={current === 'EN' ? styles.active : styles.option}
      >
        EN
      </span>
    </Typography>
  );

  if (alwaysOpen) {
    return options;
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      {options}
    </ClickAwayListener>
  );
};

export default LanguageSwitcher;
